import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";

const LargeViewportDescription = ({
  description,
  expanded,
  formatTranslation,
  onButtonClick
}) => {
  const readMoreButton = (
    <button
      className={styles.readMore}
      onClick={onButtonClick}
      data-auto-id="categoryReadMore"
    >
      {expanded
        ? formatTranslation("plp_web_view_less_button_label")
        : formatTranslation("plp_web_view_more_button_label")}
    </button>
  );

  return (
    <div
      className={classnames(styles.overflowFade, {
        [styles.expanded]: expanded
      })}
    >
      <div>
        <p>{description}</p>
      </div>
      {expanded ? (
        readMoreButton
      ) : (
        <div className={styles.after}>{readMoreButton}</div>
      )}
    </div>
  );
};

LargeViewportDescription.propTypes = {
  description: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  onButtonClick: PropTypes.func.isRequired
};

export default LargeViewportDescription;
